import api from './axiosConfig';
import {
  SubscriptionDto,
  PaymentDueDto,
  OrderInvoiceDto,
  CancellationRequest,
} from '../types';

const BASE = '/billing';

export const billingApi = {
  // ─── Subscription ─────────────────────────────────────────
  getSubscription: async (): Promise<SubscriptionDto> => {
    const response = await api.get<SubscriptionDto>(`${BASE}/subscription`);
    return response.data;
  },

  // ─── Payments Due ─────────────────────────────────────────
  getPaymentsDue: async (): Promise<PaymentDueDto[]> => {
    const response = await api.get<PaymentDueDto[]>(`${BASE}/payments-due`);
    return response.data;
  },

  // ─── Orders & Invoices ────────────────────────────────────
  getOrdersAndInvoices: async (params?: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<{ items: OrderInvoiceDto[]; totalCount: number }> => {
    const response = await api.get<{ items: OrderInvoiceDto[]; totalCount: number }>(
      `${BASE}/orders-invoices`,
      { params }
    );
    return response.data;
  },

  downloadInvoice: async (invoiceId: string): Promise<Blob> => {
    const response = await api.get(`${BASE}/orders-invoices/${encodeURIComponent(invoiceId)}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // ─── Cancellation ─────────────────────────────────────────
  requestCancellation: async (data: CancellationRequest): Promise<void> => {
    await api.post(`${BASE}/request-cancellation`, data);
  },
};
